import { render, staticRenderFns } from "./PackageCustom.vue?vue&type=template&id=98b805e8"
import script from "./PackageCustom.vue?vue&type=script&lang=js"
export * from "./PackageCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports